<template>
    <div @click="dateOff" class="wxSend 100vh sp2 wxNoscroll" style="height: 100vh;">
        <wxBack></wxBack>
        <Row style="height: 100%;">
            <div class="btmLeft" style="width: 90%;margin-left: 5%;">
                <div @click="searchDinner(9)" class="btmToday changBtm allItBtn">{{diyitian.format('MM月dd日')}}</div>
                <div @click="searchDinner(1)" class="btmToday allItBtn">{{diertian.format('MM月dd日')}}</div>
                <div @click="searchDinner(2)" class="btmToday allItBtn">{{disantian.format('MM月dd日')}}</div>
                <div @click="searchDinner(3)" class="btmToday allItBtn">{{disitian.format('MM月dd日')}}</div>
                <div @click="searchDinner(4)" class="btmToday allItBtn">{{diwutian.format('MM月dd日')}}</div>
            </div>
            <div class="bgShow">
                <div @click="modalMeal = true;" class="showMenu">
                    菜单>>>
                </div>
                <Form ref="formInline" style="margin-top: 70px;" :model="formInline" inline>
                    <FormItem prop="realname" style="width: 90%;">
                        <Row>
                            <Col class="leftName" span="6">
                                报&nbsp;&nbsp;餐&nbsp;&nbsp;人
                            </Col>
                            <Col span="17" offset="1">
                                <Input class="dataPicker toHeight" type="text" disabled v-model="formInline.realname">
                                </Input>
                            </Col>
                        </Row>
                    </FormItem>
		            <!--修改锁餐的参数：{{showIt2}}-->
                    <FormItem style="width: 90%;">
                        <Row>
                            <Col span="23" offset="1">
                                <Button class="baocanBtn" @click="eidt(0,islock)" :type="islock">{{string5}}</Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="23" offset="1">
                                <Button class="baocanBtn" style="margin-top: 20px;" @click="eidt(1,islock1)" :type="islock1">{{string6}}</Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="23" offset="1">
                            <Button class="baocanBtn" style="margin-top: 20px;" @click="eidt(2,islock4)" :type="islock4">{{dinner_state}}</Button>
                            </Col>
                        </Row>
                    </FormItem>
                    <div class="togeBtm">
                    	<Row>
                            <Col span="23" >
                                <FormItem>
	                                <Button class="suodingBtn" :type="isLockBreakfast" @click="isFalseDinner(0)">{{string1}}</Button>
	                                <Button class="suodingBtn" :type="unLockBreakfast" @click="isFalseDinner(1)">{{string2}}</Button>
	                            </FormItem>
                            </Col>
                        </Row>
                        <Row>
                        	<Col span="23" >
                                <FormItem>
	                                <Button class="suodingBtn" :type="isLockLunch" @click="isFalseDinner(2)">{{string3}}</Button>
	                                <Button class="suodingBtn" :type="unLockLunch" @click="isFalseDinner(3)">{{string4}}</Button>
	                            </FormItem>
                           </Col>
                        </Row>
                        <Row>
                            <Col span="23" >
                            <FormItem>
                                <Button class="suodingBtn" :type="isLockDinner" @click="isFalseDinner(4)">{{dinner_lock}}</Button>
                                <Button class="suodingBtn" :type="unLockDinner" @click="isFalseDinner(5)">{{dinner_unlock}}</Button>
                            </FormItem>
                            </Col>
                        </Row>
                    </div>
                    <!--<div style="font-size: 4vw;text-align: center;color: red;">-->
                        <!--早餐报餐截止时间：前一天20：00<br />-->
                        <!--午餐报餐截止时间：当日10：30-->
                    <!--</div>-->
                    <div @click="showMoadl = true;" class="showMore">
		                操作说明>>>
		            </div>
                     <!--<div style="position: absolute;top: 50px;">接口返回的锁餐值：{{showIt}} </div>-->
                    <wxNav></wxNav>
                </Form>
            </div>
            <Modal
                class="DinnerModal"
                v-model="showMoadl"
                title="功能介绍" 
                >
                <Row class="ModalRow">
                	工作日，系统默认自动报餐
                </Row>
                <Row class="ModalRow">
                    点击报餐按钮,进行报餐状态修改
                    <!-- <Button type="primary" >报餐</Button>点击后变成<br /><Button type="warning" >报餐</Button>点击后变成<br /><Button type="error" >报餐</Button>点击变成<Button type="primary" >报餐</Button> -->
                </Row>
                <Row class="ModalRow">
                	<Button style="margin-bottom: 8px;" type="primary">报餐（已报餐）</Button>为已报餐状态<br />
	                <Button style="margin-bottom: 8px;" type="warning">报餐（已留餐）</Button>为已留餐状态<br />
	                <Button style="margin-bottom: 8px;" type="error">报餐（不报餐）</Button>为未报餐状态
                </Row>
                <Row class="ModalRow">
                	<span style="margin-bottom: 8px;display:block;"><Button type="info">锁定不报餐</Button>次日起所选餐次锁定为不报餐状态</span>
                	<Button type="info">解除锁定</Button>次日起所选餐次恢复为默认报餐状态
                </Row>
                <Row class="ModalRow">
                    <div style="font-size: 4vw;text-align: center;color: red;">
                    早餐报餐截止时间：前一天24：00<br />
                    午餐报餐截止时间：当日10：30<br />
                        晚餐报餐截止时间：当日16：30
                    </div>
                </Row>
            </Modal>
            <Modal
                    class="modelMeal"
                    v-model="modalMeal"
                    title="本期菜单"
                    @on-visible-change="getStatus"
            >
                <!--<table class="tableMeal" border="">-->
                    <!--<tr>-->
                        <!--<td>-->
                            <!--日期-->
                        <!--</td>-->
                        <!--<td>-->
                            <!--餐次-->
                        <!--</td>-->
                        <!--<td>-->
                            <!--菜单-->
                        <!--</td>-->
                    <!--</tr>-->
                <!--</table>-->
                <table class="tableMeal" border="" v-for="(item,index) in mealData" :key="index">
                    <tr>
                        <td rowspan="3"><span>{{item.dateStr}}</span></td>
                        <td>早餐</td>
                        <td style="border: 1px solid #000;"><div style="display: inline-block;width: 136px">{{item.breakfast}}</div></td>
                    </tr>
                    <tr>
                        <td>午餐</td>
                        <td style="border: 1px solid #000;"><div style="display: inline-block;width: 136px">{{item.lunch}}</div></td>
                    </tr>
                    <tr>
                        <td>晚餐</td>
                        <td style="border: 1px solid #000;"><div style="display: inline-block;width: 136px">{{item.dinner}}</div></td>
                    </tr>
                </table>
            </Modal>
        </Row>
    </div>
</template>


<script>
    import { mapState, mapGetters, mapMutations } from "vuex";
    import wxNav from "../wxNav"
    import wxBack from "../wxBack"
    export default {
        props: ["wxCodeT"],
        data () {
          return{
          		string1:"加载中",
          		string2:"加载中",
          		string3:"加载中",
          		string4:"加载中",
          		string5:"加载中",
          		string6:"加载中",
          		dinner_lock:"加载中",
          		dinner_unlock:"加载中",
          		dinner_state:"加载中",
          		showIt:"",
          		showIt2:"",
                fontDay:"今天",
                isSuo:false,
                diyitian:new Date,
                diertian:new Date,
                disantian:new Date,
                disitian:new Date,
                diwutian:new Date,
                openDate:false,
                showMoadl:false,
                modalMeal:false,
                objData:{},
                mealData:[],
                islock: "success",
                islock1:"success",
                isLockBreakfast:"",
                unLockBreakfast:"",
                isLockLunch:"",
                unLockLunch:"",
                isLockDinner:"",
                unLockDinner:"",
                isLock4:"success",
          		_id: "",
          		hahah:"",

                formInline: {
                    realname: '',
                    date: new Date(),
                    shiduan:"breakfast",
                    isWait: false
                },
                isHoliday:false,
                isLiu: true,
                username:"",
                buttonV1:"加载中",
                buttonV:"加载中",
                buttonV2:"加载中",
                status:"",
                title: "个人报餐信息",
                shiduanList:[
                    {
                        value : "早餐",
                        key : "breakfast"
                    },
                    {
                        value : "午餐",
                        key : "lunch"
                    }
                ],
                dinnerState: "加载中"
            }
        },
        components:{
            wxNav,
            wxBack
        },
        computed: {
		    ...mapState(["xcxId","xcxUser","xcxReal"]),
		},
        methods:{
            ...mapMutations(["SET_XCXID","SET_XCXUSER","SET_XCXREAL","SET_LOADING"]),
            dateOn(){
                this.openDate = true;
            },
            dateOff(){
                this.openDate = false;
            },
            //第一次进入获取人员信息
            getPerson() {
//              alert('第一次进入');
//              alert(this.wxCodeT);
                var that = this;
                let params = {};
                params.url = "/manage/xiaocx/getopenId?code="+that.wxCodeT;
                params.token = "swgykj9527";
//              that.showIt = params
//              alert(JSON.stringify(params));
                params.success=function(res){
//                  alert(JSON.stringify(res));
                  console.log(res);
                  if(!res.data.result.xcx_openId){
                		alert("由于网络原因，请退出小程序从新进入");
                	}else{
                        that.watchLogin();
                        console.log("sakjdjlas")
	                    window.localStorage.setItem("wxCode",res.data.result.xcx_openId);
	                    if(res.data.code == "8888"){
                            that.SET_XCXID(res.data.result.xcx_openId);
	                        window.localStorage.setItem("isLogin",false);
	                        that.$router.replace('/data/wxSend/'+res.data.result.xcx_openId);
	                    }else if(res.data.code == "0000"){
                            that.SET_XCXID(res.data.result.xcx_openId);
                            that.SET_XCXUSER(res.data.result.username);
                            that.SET_XCXREAL(res.data.result.realname);
	                        window.localStorage.setItem("isLogin",true);
	                        that.formInline.realname = res.data.result.realname;
	                        that.username = res.data.result.username;
	                        that.searchDinner();
	                        that.getIsFalse();
	                    }
                	}
                };
                that.ajaxPostWX(params);
            },
            //解绑后二次绑定进入获取人员信息
            getPerson2() {
//              alert('第二次进入');
                let that = this;
                that.watchLogin();
                window.localStorage.setItem("isLogin","true");
                that.formInline.realname = this.xcxReal;
                that.username = this.xcxUser;
                that.searchDinner();
                that.getIsFalse();
              console.log(8888);
            },
            //查找人员报餐状态
            searchDinner(e){
//              alert(JSON.stringify(e));
                this.isSuo = false;
                var time;
                var that = this;
                let params = {};
                if(e == 1){
                    time = this.diertian.format("yyyy-MM-dd");
                    this.fontDay = "明天";
                    this.setTopStyle(1);
                }else if(e == 2){
                    this.fontDay = "后天";
                    time = this.disantian.format("yyyy-MM-dd");
                    this.setTopStyle(2);
                }else if(e == 9){
                    this.fontDay = "今天";
                    time = this.diyitian.format("yyyy-MM-dd");
                    this.setTopStyle(0);
                }else if(e == 3){
                  this.fontDay = "第四天";
                  time = this.disitian.format("yyyy-MM-dd");
                  this.setTopStyle(3);
                }else if(e == 4){
                  this.fontDay = "第五天";
                  time = this.diwutian.format("yyyy-MM-dd");
                  this.setTopStyle(4);
                }else{
                    if(this.fontDay == "今天"){
                        time = this.diyitian.format("yyyy-MM-dd");
                        this.setTopStyle(0);
                    }else if(this.fontDay == "明天"){
                        time = this.diertian.format("yyyy-MM-dd");
                        this.setTopStyle(1);
                    }else if(this.fontDay == "后天"){
                        time = this.disantian.format("yyyy-MM-dd");
                        this.setTopStyle(2);
                    }else if(this.fontDay == "第四天"){
                      time = this.disitian.format("yyyy-MM-dd");
                      this.setTopStyle(3);
                    }else if(this.fontDay == "第五天"){
                      time = this.diwutian.format("yyyy-MM-dd");
                      this.setTopStyle(4);
                    }
                }
                this.formInline.date = new Date(time.split("-")[0],time.split("-")[1]-1,time.split("-")[2]);
                params.url = "/sys/mealrecord/userviewdate";
                params.token = "swgykj9527";
                params.data = {
                    "username" : that.xcxUser,
                    "meal_date" : time
                },
                params.success=function(res){
//                  alert(JSON.stringify(res));
                  console.log(res);
                  that.watchLogin();
                    if(res.data.result.breakfast_state == "true"){
                        that.buttonV = "留餐";
                        that.islock =  "primary";
                        that.string5 = "早餐(已报餐)";
                    }else if(res.data.result.breakfast_state == "wait"){
                        that.buttonV = "取消报餐";
                        that.islock =  "warning";
                        that.string5 = "早餐(已留餐)";
                    }else if(res.data.result.breakfast_state == "false"){
                        that.buttonV = "确定报餐";
                        that.islock =  "error";
                        that.string5 = "早餐(不报餐)";
                    }
                    if(res.data.result.lunch_state == "true"){
                        that.buttonV1 = "留餐";
                        that.islock1 =  "primary";
          			    that.string6 = "午餐(已报餐)";
                    }else if(res.data.result.lunch_state == "wait"){
                        that.buttonV1 = "取消报餐";
                        that.islock1 =  "warning";
          			    that.string6 = "午餐(已留餐)";
                    }else if(res.data.result.lunch_state == "false"){
                        that.buttonV1 = "确定报餐";
                        that.islock1 =  "error";
          			    that.string6 = "午餐(不报餐)";
                    }
                  if(res.data.result.dinner_state == "true"){
                    that.buttonV2 = "留餐";
                    that.islock4 =  "primary";
                    that.dinner_state = "晚餐(已报餐)";
                  }else if(res.data.result.dinner_state == "wait"){
                    that.buttonV2 = "取消报餐";
                    that.islock4 =  "warning";
                    that.dinner_state = "晚餐(已留餐)";
                  }else if(res.data.result.dinner_state == "false"){
                    that.buttonV2 = "确定报餐";
                    that.islock4 =  "error";
                    that.dinner_state = "晚餐(不报餐)";
                  }
                };
                if(that.xcxUser && that.xcxReal){
                    that.ajaxPostWX(params);
                }
            },
          //查询本期菜单
            getMealMenu(){
              let that=this;
              var week = ["星期一","星期二","星期三","星期四","星期五"];
              var len = 5;
              for(var i=0;i<len;i++){
                var obj = {
                  dateStr: week[i],
                  breakfast: "",
                  lunch: "",
                  dinner:""
                };
                this.mealData.push(obj);
                var params = {
                  data: {},
                  token: "swgykj9527",
                  url: '/sys/bookmealsetting/list',
                  success: (res) => {
                    var data = res.data.result.result[0];
                    that.mealData[0].breakfast = data.Monday_breakfast;
                    that.mealData[0].lunch = data.Monday_lunch;
                    that.mealData[0].dinner = data.Monday_dinner;
                    that.mealData[1].breakfast = data.Tuesday_breakfast;
                    that.mealData[1].lunch = data.Tuesday_lunch;
                    that.mealData[1].dinner = data.Tuesday_dinner;
                    that.mealData[2].breakfast = data.Wednesday_breakfast;
                    that.mealData[2].lunch = data.Wednesday_lunch;
                    that.mealData[2].dinner = data.Wednesday_dinner;
                    that.mealData[3].breakfast = data.Thursday_breakfast;
                    that.mealData[3].lunch = data.Thursday_lunch;
                    that.mealData[3].dinner = data.Thursday_dinner;
                    that.mealData[4].breakfast = data.Friday_breakfast;
                    that.mealData[4].lunch = data.Friday_lunch;
                    that.mealData[4].dinner = data.Friday_dinner;
                  }
                }
                this.ajaxPostWX(params)
                // }
              }
            },
            lock(){
                this.isSuo = true;
            },
            setTopStyle(i){
                var ele = document.getElementsByClassName("allItBtn");
                for(var j = 0;j<ele.length;j++){
                    ele[j].classList.remove("toBlue");
                }
                ele[i].classList.add("toBlue");
            },
            //修改人员报餐状态
            eidt(e,sta){
            	var time;
                if(this.fontDay == "今天"){
                    time = this.diyitian.format("yyyy-MM-dd");
                }else if(this.fontDay == "明天"){
                    time = this.diertian.format("yyyy-MM-dd");
                }else if(this.fontDay == "后天"){
                    time = this.disantian.format("yyyy-MM-dd");
                }else if(this.fontDay == "第四天"){
                  time = this.disitian.format("yyyy-MM-dd");
                }else if(this.fontDay == "第五天"){
                  time = this.diwutian.format("yyyy-MM-dd");
                }
                var that = this;
                var editShiduan = "";
                if(e == 0){
                    editShiduan = "breakfast";
                }else if(e == 1){
                    editShiduan = "lunch";
                }else if(e==2){
                  editShiduan = "dinner";
                }
                let params = {};
                // alert(that.dinnerState);
                if(sta == "warning"){
                    that.status = "delete";
                }else if(sta == "primary"){
                    that.status = "wait";
                }else if(sta == "error"){
                    that.status = "add";
                }
                params.url = "/sys/mealrecord/usereditinfo";
                params.token = "swgykj9527";
                if(that.username == "" || that.username=="xianrq"){
                	alert("由于网络原因，请退出小程序从新进入");
                	return false;
                }
                params.data = { 
                    "username" : that.username,
                    "meal_date" : time,
                    "meal_type":editShiduan,
                    "edit_type": that.status
                },
                params.success=function(res){

                	that.watchLogin();
                    if(res.data.code = "0000"){
                    	if(res.data.message == "超过报餐截止时间，无法修改订餐信息"){
                    		that.$Message.success({
	                            content: res.data.message
	                        });
                    	}else{
                    		that.$Message.success({
	                            content: res.data.message
                            });
	                        that.searchDinner();
                    	}
                    }else{
                        that.$Message.warning({
                            content: "由于网络原因，请退出小程序从新进入"
                        });
                        that.searchDinner();
                    }
				    that.$store.commit('SET_LOADING',false);                    
                };
                // alert(JSON.stringify(params.data));
                that.ajaxPostWX(params);
            },
            watchLogin(){
            	var ele = document.getElementById("loginPage");
            	if(ele){
            		ele.style.display = "none";
            	}
            },
            getIsFalse(){
            	var that = this;
                let params = {};
                params.url = "/sys/userbooksetting/view";
                params.token = "swgykj9527";
                params.data = {
                    "username" : that.xcxUser,
                },
                params.success=function(res){
//              	alert(JSON.stringify(res.data.result));
                	that.changeFlse(res.data.result);  
                	that.showIt = res.data.result
                };
                that.ajaxPostWX(params);
            },
            changeFlse(res){
            	this.objData = {
            		_id : res._id,
            		book_breakfast : res.book_breakfast,
            		book_lunch : res.book_lunch,
            		book_dinner : res.book_dinner
            	}
            	this.string1 = "早餐解除锁定";
          		this.string2 = "早餐锁定不报餐";
          		this.string3 = "午餐解除锁定";
          		this.string4 = "午餐锁定不报餐";
                this.dinner_lock = "晚餐解除锁定";
          		this.dinner_unlock = "晚餐锁定不报餐";
//          	alert(this.objData.book_lunch);
            	this._id = res._id;
                if(this.objData.book_breakfast == false || this.objData.book_breakfast == "false"){
                    this.isLockBreakfast = "info";
                    this.unLockBreakfast = "";
                }else{
                    this.isLockBreakfast = "";
                    this.unLockBreakfast = "info";
                }
                if(this.objData.book_lunch == false || this.objData.book_lunch == "false"){
                    this.isLockLunch = "info";
                    this.unLockLunch = "";
                }else{
                    this.isLockLunch = "";
                    this.unLockLunch = "info";
                }
              if(this.objData.book_dinner == false || this.objData.book_dinner == "false"){
                this.isLockDinner = "info";
                this.unLockDinner = "";
              }else{
                this.isLockDinner = "";
                this.unLockDinner = "info";
              }
            },
            isFalseDinner(e){
            	var that = this;
                let params = {};
                params.url = "/sys/userbooksetting/edit";
                params.token = "swgykj9527";
                params.data = this.objData;
                if(e == 0){
                	params.data.book_breakfast = false;
                }else if(e == 1){
                    params.data.book_breakfast = true;
                }else if(e == 2){
                	console.log(e);
                    params.data.book_lunch = false;
                }else if(e == 3){
                    params.data.book_lunch = true;
                }else if(e == 4){
                  params.data.book_dinner = false;
                }else if(e == 5){
                  params.data.book_dinner = true;
                }
                that.showIt2 = params.data;
                params.success=function(res){
                    setTimeout(()=>{
                    	that.getIsFalse();
                    	that.searchDinner();
                		that.$Message.success(res.data.message);
                    },50)
                };
//              alert(JSON.stringify(params.data));
                // alert(JSON.stringify(params.data));
                that.ajaxPostWX(params);
            },
            getThreeDay(){
                var that = this;
                let params = {};
                params.url = "/sys/mealrecord/workdate";
                params.token = "swgykj9527";
              params.success=function(res){
//                alert(121212)
//                alert(JSON.stringify(res))
                  var firstTime = res.data.result[0].split("-");
                    var secondTime = res.data.result[1].split("-");
                    var thirdTime = res.data.result[2].split("-");
                    var fourthTime = res.data.result[3].split("-");
                    var fifthTime = res.data.result[4].split("-");
                    that.diyitian = new Date(firstTime[0],firstTime[1]-1,firstTime[2]);
                    that.diertian = new Date(secondTime[0],secondTime[1]-1,secondTime[2]);
                    that.disantian = new Date(thirdTime[0],thirdTime[1]-1,thirdTime[2]);
                    that.disitian = new Date(fourthTime[0],fourthTime[1]-1,fourthTime[2]);
                    that.diwutian = new Date(fifthTime[0],fifthTime[1]-1,fifthTime[2]);
                    that.afterRun();
                    that.getMealMenu()
                };
                that.ajaxPostWX(params);
            },
            afterRun(){
//              alert(777777)
//              alert(this.xcxId)
                if(new Date().format("yyyy-MM-dd")< this.diyitian.format("yyyy-MM-dd")){
                    setTimeout(()=>{
	                    this.fontDay = "今天";
	                	if(this.xcxId){
		                    this.getPerson2();
		                }else{
		                    this.getPerson();
		                }
					},10)
                }else if((parseInt(this.formInline.date.format("hh"))>=9 && parseInt(this.formInline.date.format("hh"))<13)){
	                setTimeout(()=>{
	                    this.fontDay = "今天";
	                	if(this.xcxId){
		                    this.getPerson2();
		                }else{
		                    this.getPerson();
		                }
					},10)
	            }else if(parseInt(this.formInline.date.format("hh"))>=13 && this.formInline.date.format("hh-mm")<('18-30')){
	                this.fontDay = "明天";
	                if(this.xcxId){
	                    this.getPerson2();
	                }else{
	                    this.getPerson();
	                }
	            }else if(this.formInline.date.format("hh-mm")>('18-30')){
	                this.fontDay = "明天";
					setTimeout(()=>{
	                	this.formInline.shiduan = "lunch";
	                	if(this.xcxId){
		                    this.getPerson2();
		                }else{
		                    this.getPerson();
		                }
					},10)
	            }else if(parseInt(this.formInline.date.format("hh"))<9){
	                this.fontDay = "今天";
                    setTimeout(()=>{
                        this.formInline.shiduan = "lunch";
                        if(this.xcxId){
                            this.getPerson2();
                        }else{
                            this.getPerson();
                        }
                    },10)
	            }
            }
        },
        watch:{
            
        },
        mounted: function() {

//          this.diertian=new Date((this.diyitian.getTime()+1*(1000*60*60*24)))
//          this.disantian=new Date((this.diyitian.getTime()+2*(1000*60*60*24)))
//          this.disitian=new Date((this.diyitian.getTime()+3*(1000*60*60*24)))
//          this.diwutian=new Date((this.diyitian.getTime()+4*(1000*60*60*24)))
          this.SET_LOADING("yes");
            this.getThreeDay();
//          alert(this.diwutian.format("yyyy-MM-dd"))
	    }
    }
</script>

<style lang="scss">
    .modelMeal{
        width: 95%;
        text-align: center;
        .ivu-modal{
            top: 0;
        }
    }
    .tableMeal{
        overflow-y: scroll;
        overflow-x: hidden;
        text-align: center;
        border-top: 0;
        border-color: #000;
        margin: 0 auto;
        font-size: 14px;
        color: #474444;
        border: 0;
    td{
        width: 200px;
        word-break: break-all;
        height: 50px;
    input{
        height: 100%;
        width: 100%;
        border: 0;
        padding: 5px;
        display: inline-block;
    }
    }
    td:last-child{
        width: 235px;
    }
    }
    .DinnerModal{
        .ivu-modal{
            top: 3%;
        }
        .ModalRow{
            font-size: 18px;
            margin-bottom: 3vw;
        }
    }
    .sp2{
        background: url("../../assets/wxBg.png") center -150px no-repeat;
        height: 100%;
        font-size: 4vw;
        .baocanBtn{
            width: 100%;
            height: 12vw;
            margin: 0;
            font-size: 4vw;
        }
        .baocanBtn:nth-child(2){
            margin-top: 20px;
        }
        .btmLeft{
            height: 16vw;
            line-height: 16vw;
            display: flex;
            justify-content: space-around;
            position: absolute;
            width: 100%;
            left: 0;
            box-shadow: 0px 3px 3px #ccc;
            top: 0;
            .allItBtn{
                width: 100%;
                font-size: 4vw;
            }
            .toBlue{
                color: #45aaf9;
                position: relative;
            }
            .toBlue:after{
            	content: "";
            	position: absolute;
            	width: 60%;
            	height: 3px;
            	left: 20%;
            	background: #45AAF9;
            	bottom: 0;
            }
        }
        .ivu-form-inline .ivu-form-item{
            margin-bottom: 6vw;
        }
        .showMenu{
            color: #333;
            font-size: 14px;
            float: right;
            margin-right: 7.5%;
            position: absolute;
            right: 0;
            top: 65px;
        }
        .showMore{
            color: #333;
            font-size: 14px;
            float: right;
            margin-right: 7.5%;
            position: absolute;
            right: 0;
            bottom: 65px;
        }
        .dataPicker{
            height: 12vw;
            width: 100%;
        }
        .ivu-checkbox-wrapper{
            font-size: 4vw;
        }
        .ivu-select-small.ivu-select-single .ivu-select-selection{
        	height: 100%;
        }
        .ivu-select-small.ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-small.ivu-select-single .ivu-select-selection .ivu-select-selected-value{
        	height: 100%;
        	line-height: 12vw;
        }
        .togeBtm{
            left: 0;
            right: 0;
            bottom: 50vw;
            .statusFont{
                font-size: 4vw;
                height: 12vw;
                line-height: 12vw;
                color: #706767;
                span{
                    text-indent: 1vw;
                    color: #e04c5b;
                }
            }
            .ivu-form-item-content{
                width: 90%;
                margin-left: 7.5%;
                line-height: unset;
            }
            .ivu-form-item{
                width: 100%;
                height: 8vw;
                line-height: 10vw;
                .ivu-btn{
                    width: 50%;
                    height: 100%;
                    float: left;
                    font-size: 4vw;
                    height: 10vw;
                    color: #807b7b;
                    background: transparent;
                }
                .ivu-btn:first-child{
                	border-bottom-right-radius: 0;
                	border-top-right-radius: 0;
                }
                .ivu-btn:last-child{
                	border-bottom-left-radius: 0;
                	border-top-left-radius: 0;
                }
                .ivu-btn-info{
                	color: #fff;
                	background: #2db7f5;
                }
            }
        }
        .toHeight{
            .ivu-input[disabled], fieldset[disabled] .ivu-input{
                height: 100%;
                font-size: 4vw;
            }
            .ivu-date-picker-rel{
                height: 100%;
                font-size: 4vw;
            }
            .ivu-input-icon-normal+.ivu-input,.ivu-input-wrapper{
                height: 100%;
                font-size: 4vw;
            }
            .ivu-icon-ios-calendar-outline:before{
                top: 6px;
                position: relative;
                font-size: 4vw;
            }
            .ivu-select-selection{
                height: 100%;
                .ivu-select-selected-value{
                    line-height: 12vw;
                    font-size: 4vw;
                    height: 12vw;
                }
            }
        }
        .bgShow{
            background: #fff;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            height: 100%;
            width: 90%;
            padding-top: 10vw;
            margin: 0 auto;
            .leftName{
                line-height: 12vw;
                font-size: 4vw;
                height: 12vw;
                text-align: center;
                color: #706767;
            }
        }
    }
    
    .wxSend{
        max-width: 768px;
        margin: 0 auto;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/dinnerMana/wxDinner.vue